module.exports = __webpack_public_path__ + "img/Card_spade_10.b52345fa.svg";